import { api, requetFile } from './api.config'


export const registrarNuevoPeriodo = async ( data ) => {
    return await api.post(`admin/periodo`, data)
}

export const actualizarPeriodo = async ( id_periodo, data ) => {
    return await api.put(`admin/periodo/${id_periodo}`, data)
}

export const getFiltros = async ( ) => {
    return await api.get(`admin/filtros`)
}

export const getConteoRegistros = async ( filtro_sede = 0, filtro_apoyo = 0, filtro_periodo = 0 ) => {
    return await api.get(`admin/count/${filtro_sede}/${filtro_apoyo}/${filtro_periodo}`)
}

export const searchUsuario = async ( usuario ) => {
    return await api.get(`admin/search/${usuario}`)
}

export const getInfoUsuario = async ( documento ) => {
    return await api.get(`admin/usuario/${documento}`)
}

export const updateCorreoUsuario = async ( documento, correo ) => {
    return await api.put(`admin/usuario/correo/${documento}`, correo)
}

export const getReporteExcel = async ( filtro_sede = 0, filtro_apoyo = 0, filtro_periodo = 0 ) => {
    return await api.get(`admin/reporte/${filtro_sede}/${filtro_apoyo}/${filtro_periodo}`)
}

export const downloadZip = async ( filtro_sede = 0, filtro_apoyo = 0, filtro_periodo = 0 ) => {
    return await requetFile(`admin/download/${filtro_sede}/${filtro_apoyo}/${filtro_periodo}`)
}


